import React from 'react';
import classnames from 'classnames';
import styles from './styles.styl';
import baseStyles from 'custom/base.styl';

const renderIcon = (icon) => {
  return (<i className={baseStyles.icon_question} />)
}

const Tooltip = (props) => {
  const { children, positionLeft, positionRight, containerClass, typeIcon, light, small, renderContent } = props;
  return (
    <div className={classnames(styles.container, containerClass, { [styles.light]: light })}>
      <span className={styles.trigger} onMouseOver={props.onMouseOver}>
        {typeIcon &&
          renderIcon(typeIcon)
        }
        {renderContent &&
          renderContent()
        }
      </span>
      <span className={classnames(styles.content, {
        [styles.position_left]: positionLeft,
        [styles.position_right]: positionRight,
        [styles.small]: small,
      })}>
        {children}
      </span>
    </div>
  );
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/shared/Tooltip/index.js